import React from 'react';
import { CardProps } from '../../types';
import { clsx } from 'clsx';

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hover = false,
  padding = 'md',
}) => {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const classes = clsx(
    'bg-white rounded-xl shadow-soft border border-slate-100 transition-all duration-200',
    paddingClasses[padding],
    {
      'hover:shadow-medium hover:-translate-y-0.5 cursor-pointer': hover,
    },
    className
  );

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

export default Card;
